import { render, staticRenderFns } from "./d2.vue?vue&type=template&id=4c3cc37a&scoped=true"
import script from "./d2.vue?vue&type=script&lang=js"
export * from "./d2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3cc37a",
  null
  
)

export default component.exports